export class User {
    uid!: string;
    username!: string;
    email!: string;
    active!: boolean;
}
